<template>
  <transition name="fade">
    <div
      v-if="validSrc"
      :key="`content-modal-${validSrc || 'false'}`"
      class="ContentModalComp f-cover z-50 overflow-hidden p-10vh flex justify-center items-center"
    >
      <!-- Overlay -->
      <div
        class="a-cover overflow-hidden"
        :class="`bg-${overlayStyles.bg_color} opacity-${overlayStyles.opacity}`"
      />
      <button
        :class="closeClasses"
        :title="htmlDecode(closeTitle)"
        :aria-label="htmlDecode(closeTitle)"
        @click="$store.commit('contentModal', false)"
      >
        <SvgIcon
          icon="cross"
          class="w-6 h-6"
        />
      </button>
      <div class="r-cover overflow-hidden">
        <iframe
          class="r-cover overflow-hidden"
          :src="contentModal"
          width="100%"
          height="100%"
          allowfullscreen="true"
          allow="picture-in-picture"
          :title="`iframe: ${contentModal}`"
          :aria-label="`iframe: ${contentModal}`"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ContentModal',

  components: {
    SvgIcon,
  },

  computed: {
    ...mapState([ 'contentModal' ]),
    ...mapGetters([ 'myStore' ]),
    // Styles
    mediaStyles() { return this.myStore(['styles', 'media_screens']) ?? {} },
    overlayStyles() { return this.mediaStyles.background ?? {} },
    // Data
    validSrc() {
      if (!this.contentModal) { return }
      const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i') // fragment locator
      return !!pattern.test(this.contentModal)
    },
    // Close btn
    closeClasses() {
      // Data
      const settings = this.mediaStyles.close_button ?? {}
      const focusStyles = settings.focus ?? {}
      const hoverStyles = settings.hover ?? {}
      // Return
      return [
        'absolute right-0 top-0 w-10 h-10 z-1',
        'flex-c',
        `border-${settings.border_width ?? 1}`,
        `border-${settings.border_color} focus:border-${focusStyles.border_color} lg:hover:border-${hoverStyles.border_color}`,
        `rounded-bl-${settings.border_radius ?? 5}`,
        `bg-${settings.bg_color} focus:bg-${focusStyles.bg_color} lg:hover:bg-${hoverStyles.bg_color}`,
        `fill-${settings.fill_color} focus:fill-${focusStyles.fill_color} lg:hover:fill-${hoverStyles.fill_color}`,
        'transition-colors duration-500 ease-in-out',
        'focus:outline-none'
      ]
    },
    closeTitle() { return this.myStore(['labels', 'media_screens', 'close_button', 'btn_title']) ?? 'Close window' },
  },
}
</script>

